import { Box } from '@chakra-ui/react';
import React from 'react';

import { Spacers } from 'shared_DEPRECATED/components/Spacer';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { ChatFormAttachmentReply } from 'features/chat//components/ChatForm/components/AttachmentReply';
import { ChatScrollToMessage } from 'features/chat/components/ChatScrollToMessage';
import { UUID } from 'features/chat/config/types/Message';
import { useChatContext } from 'features/chat/context/chat';

import { Typography } from 'shared/components/Typography';

export type ChatMessageParentProps = {
  incoming: boolean;
  replyToMessage?: string;
  fromUserId: UUID;
  messageId: string;
  attachments?: Attachment[];
};

export const ChatMessageParent = ({
  incoming,
  replyToMessage,
  fromUserId,
  messageId,
  attachments,
}: ChatMessageParentProps) => {
  const { members } = useChatContext();

  const fromUserName = members.find(
    (member: { userId: string }) => member.userId === fromUserId
  )?.name;

  const borderLeft = `3px solid rgba(${
    incoming ? '0, 0, 0' : '255, 255, 255'
  }, 0.5)`;

  return (
    <Spacers sizes={['md', 'zr sm']}>
      <Box borderLeft={borderLeft}>
        <Spacers sizes={['zr md zr']}>
          <ChatScrollToMessage messageId={messageId}>
            <Box opacity={0.5}>
              <Typography
                type="small"
                color={incoming ? 'blackTotal' : 'whiteTotal'}
                textAlign="start"
              >
                Reply to {fromUserName}
              </Typography>
              <Box maxW="14rem">
                <Typography
                  type="small"
                  color={incoming ? 'blackTotal' : 'whiteTotal'}
                  cropped={true}
                  textAlign="start"
                >
                  {replyToMessage || (
                    <ChatFormAttachmentReply attachments={attachments} />
                  )}
                </Typography>
              </Box>
            </Box>
          </ChatScrollToMessage>
        </Spacers>
      </Box>
    </Spacers>
  );
};
